import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AgrEnvironment, EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';

import { Notification } from '../models/notification.model';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private readonly env = inject<AgrEnvironment>(EnvironmentInjector);
  protected readonly http = inject(HttpClient);
  protected baseUrl = this.env.APIM_BASE_URL + '/user-notification-service/notifications';

  getNotifications(): Observable<Notification[]> {
    return this.http.get<Notification[]>(this.baseUrl);
  }

  upsertNotification(notification: Notification): Observable<Notification> {
    if (notification.id === null || notification.id === 0) {
      const { id, ...notificationWithoutId } = notification;
      return this.http.post<Notification>(this.baseUrl, notificationWithoutId);
    } else {
      return this.http.put<Notification>(`${this.baseUrl}/${notification.id}/`, notification);
    }
  }

  softDeleteNotification(id: number): Observable<void> {
    return this.http.patch<void>(`${this.baseUrl}/${id}/soft-delete`, {});
  }
}
